import { defineStore } from 'pinia'
import { useAuthStore } from './auth'
import axios from '../plugins/axios'

export const useSentinelDashboardStore = defineStore('sentinelDashboard', {
  state: () => ({
    data: null,
    loading: false,
    refreshing: false,
    error: null,
    lastRefreshed: null,
  }),

  getters: {
    situationsByStage: (state) => state.data?.situations_by_stage ?? [],
    topSituations: (state) => state.data?.top_situations ?? [],
    recentSignals: (state) => state.data?.recent_signals ?? [],
    domainBreakdown: (state) => state.data?.domain_breakdown ?? {},
    signals24hCount: (state) => state.data?.signals_24h_count ?? 0,
    mapData: (state) => state.data?.map_data ?? [],
    canRefresh: () => {
      const auth = useAuthStore()
      return auth.isAdmin
    },
  },

  actions: {
    async fetchDashboard() {
      this.loading = true
      this.error = null

      try {
        const response = await axios.get('/api/sentinel/dashboard')
        this.data = response.data.data
        this.lastRefreshed = new Date()
      } catch (error) {
        this.error = error.response?.data?.message || 'Failed to fetch dashboard'
      } finally {
        this.loading = false
      }
    },

    async refreshSignals() {
      const auth = useAuthStore()
      
      if (!auth.isAdmin) {
        this.error = 'Only administrators can refresh signals'
        return { success: false, error: this.error }
      }

      this.refreshing = true
      this.error = null

      try {
        await axios.post('/api/sentinel/dashboard/refresh', null, { timeout: 120000 })
        await this.fetchDashboard()
        return { success: true }
      } catch (error) {
        if (error.response?.status === 403) {
          this.error = 'Admin access required to refresh signals'
        } else {
          this.error = error.response?.data?.message || error.response?.data?.error || 'Failed to fetch signals'
        }
        return { success: false, error: this.error }
      } finally {
        this.refreshing = false
      }
    },
  },
})